import React, { useRef } from 'react';
import "./SignUpScreen.css";
import { auth } from '../firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth"; // ✅ Import necessary functions

function SignUpScreen() {
  const emailRef = useRef(null);
  const passwordRef = useRef(null);

  const register = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        emailRef.current.value,
        passwordRef.current.value
      );
      console.log("User registered:", userCredential.user);
    } catch (error) {
      alert(error.message);
    }
  };

  const signIn = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        emailRef.current.value,
        passwordRef.current.value
      );
      console.log("User signed in:", userCredential.user);
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className='sign-up-screen'>
      <form>
        <h1>Sign In</h1>
        <input ref={emailRef} placeholder='Email' type='email' />
        <input ref={passwordRef} placeholder='Password' type='password' />
        <button type='submit' onClick={signIn}>Sign In</button>
      </form>
      <h4>
        <span className='sign-up-screen-gray'> New to Netflix? </span>
        <span className='sign-up-screen-link' onClick={register}> Sign Up Now. </span>
      </h4>
    </div>
  );
}

export default SignUpScreen;
